var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightBlubBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 22H7.33333M22 5.5V7.33333M36.6667 22H38.5M10.2667 10.2667L11.55 11.55M33.7333 10.2667L32.45 11.55",
    stroke: "#00ABFB",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 29.3333C14.9609 28.179 13.8239 26.5696 13.2503 24.7332C12.6766 22.8968 12.6953 20.9264 13.3037 19.1013C13.9121 17.2761 15.0794 15.6886 16.6402 14.5636C18.2009 13.4387 20.0761 12.8333 22 12.8333C23.9239 12.8333 25.7991 13.4387 27.3598 14.5636C28.9206 15.6886 30.0879 17.2761 30.6963 19.1013C31.3047 20.9264 31.3234 22.8968 30.7497 24.7332C30.1761 26.5696 29.0391 28.179 27.5 29.3333C26.7842 30.0419 26.2453 30.909 25.9268 31.8645C25.6083 32.82 25.5192 33.837 25.6667 34.8333C25.6667 35.8058 25.2804 36.7384 24.5927 37.4261C23.9051 38.1137 22.9725 38.5 22 38.5C21.0275 38.5 20.0949 38.1137 19.4073 37.4261C18.7196 36.7384 18.3333 35.8058 18.3333 34.8333C18.4808 33.837 18.3917 32.82 18.0732 31.8645C17.7547 30.909 17.2158 30.0419 16.5 29.3333Z",
    stroke: "#00ABFB",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7833 31.1667H26.2167",
    stroke: "#00ABFB",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightBlubBlue);
export default __webpack_public_path__ + "static/media/Icon_LightBlub_Blue.22bd95dbe0fc4b810565aed9d31a119f.svg";
export { ForwardRef as ReactComponent };